<div class="main-db gap-top">
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col-12 col-sm-10">
        <h1>{{title}}</h1>
      </div>
      <div class="col-12 col-sm-2 mb-2">
        <button class="btn btn-sm btn-success float-right" (click)="addExpiryDialog()">
          <i class="fas fa-plus mr-1"></i> Add License Expiry
        </button>
      </div>
      <div class="col-12">
        <div class="">
          <input type="text" class="form-control form-control-sm input-custom" aria-label="search" (keyup)="applyFilter($event)" placeholder="Search" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        <div class="table-responsive db-block" style="height: auto !important;">
          <i class="fa fa-database mr-2" aria-hidden="true"></i>
          <span>{{title}}</span>
          <table mat-table [dataSource]="dataSource" class="gridData mt-2" matSort>
            <ng-container matColumnDef="organizationName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Organization</th>
              <td mat-cell *matCellDef="let element"> {{element.organization.name}} </td>
            </ng-container>

            <ng-container matColumnDef="expiryDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiry Date</th>
              <td mat-cell *matCellDef="let element"> {{element.expiry_Date | date:'y-MM-dd'}} </td>

            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.status == 1; else inactive">Active</span>
                <ng-template #inactive><span>Inactive</span></ng-template>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Action</th>
              <td mat-cell *matCellDef="let element">

                <button mat-icon-button matTooltip="Click to Edit" class="iconbutton text-warning float-left" aria-label="edit" (click)="updateExpiryDialog(element)">
                  <mat-icon aria-label="Edit">edit</mat-icon>
                </button>

                
                <button mat-icon-button  matTooltip="Click to Delete" (click)="getTempId(element)" class="iconbutton text-danger" data-toggle="modal" data-target="#deletePrompt">
                  <mat-icon aria-label="Delete">delete</mat-icon>
                </button>

        <!-- Modal -->

        <div class="modal fade" id="deletePrompt" tabindex="-1" role="dialog" aria-labelledby="deletePromptLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title orange-text" id="deletePromptLabel">Delete License </h5>
                <button type="button" class="close" aria-label="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                Are you sure you want to delete license?
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger" (click)="deletelicenseExpiry()" data-dismiss="modal">Confirm</button>
              </div>
            </div>
          </div>
        </div>

            </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
